<template>
    <vx-table-row>
        <vx-table-row-title>
            <div class="flex items-center">
            <div class="w-4 h-4 rounded-full mr-2 shrink-0"
                :class="status[props.item.status].color"></div>
            <span class="font-normal">{{ status[props.item.status].label || 'Unknown' }}</span>
            </div>
        </vx-table-row-title>

        <vx-table-row-item>
            <template v-slot:label> Triggered: </template>

            <vx-popover hover
                :arrow="true"
                placement="top"
                :key="createdAtKey">
                {{ fromNow(props.item.created_at) }}
                <template v-slot:content>
                    {{ shortDateTime(props.item.created_at) }}
                </template>
            </vx-popover>

        </vx-table-row-item>
        <vx-table-row-item>
            <template v-slot:label> Delivery ID: </template>

            <vx-popover hover
                :arrow="true"
                placement="top">
                <vx-badge size="xs"
                    color="slate">{{ props.item.delivery_id?.slice(-6) }}</vx-badge>
                <template v-slot:content>
                    {{ props.item.delivery_id }}
                </template>
            </vx-popover>
        </vx-table-row-item>
        <vx-table-row-item>
            <template v-slot:label> Automation: </template>
            <div v-if="props.item.delivery_source?.startsWith('automated_action')">
                <vx-popover v-if="props.automationRule?.name"
                    hover
                    :arrow="true"
                    placement="top"
                    class="max-w-full">
                    <a v-if="props.automationRule?.name"
                        :href="'/automation/event/' + automationRule?.id"
                        class="block truncate underline underline-offset-1 decoration-slate-200 text-slate-800 hover:text-sky-500">
                        {{ props.automationRule?.name }}
                    </a>
                    <template v-slot:content>
                        <div class="font-extrabold">Go to Automation:</div>
                        {{ props.automationRule?.name }}
                    </template>
                </vx-popover>

                <vx-icon-loading spin v-if="props.automationRule === undefined"></vx-icon-loading>
                <vx-popover v-if="props.automationRule === null"
                    hover
                    :arrow="true"
                    placement="top">
                    <span>
                        <font-awesome-icon widthAuto :icon="faCircleInfo"></font-awesome-icon>
                        Not Found
                    </span>
                    <template v-slot:content>
                        An automation was used but the name couldn't be found.
                    </template>
                </vx-popover>
            </div>
            <div v-else> None </div>
        </vx-table-row-item>

        <vx-table-row-buttons>
            <vx-button class="w-full md:w-auto"
                :href="`/settings/integrations/api-destinations/${props.item.origin_id}/deliveries/${props.item.delivery_id}`"
                color="muted"
                outline>
                Details
                <font-awesome-icon widthAuto :icon="faArrowRight" />
            </vx-button>
        </vx-table-row-buttons>

    </vx-table-row>
</template>

<script setup>
import {
    faCircleInfo,
    faArrowRight
} from "@fortawesome/pro-solid-svg-icons";
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import {
    VxButton,
    VxTableRow,
    VxTableRowButtons,
    VxTableRowItem,
    VxTableRowTitle,
    VxBadge,
    VxPopover,
    VxIconLoading,
} from '@voxie/frontend-components';
import { useInterval } from '@vueuse/core';
import { fromNow, shortDateTime } from '../../../../../utils/date';

const status = {
    triggered: {
        color: 'bg-slate-300',
        label: 'In Progress',
    },
    succeeded: {
        color: 'bg-sky-200',
        label: 'Success',
    },
    failed: {
        color: 'bg-rose-400',
        label: 'Failed',
    },
};

const props = defineProps({
    item: {
        type: Object,
        required: true,
    },
    automationRule: {
        required: false,
    },
});

const createdAtKey = useInterval(60000);

</script>
